import {
    DeleteOutlined,
    EditOutlined,
    PlusOutlined,
    QuestionCircleOutlined,
} from "@ant-design/icons";
import {
    Button,
    Card,
    DatePicker,
    Form,
    Input,
    Modal,
    Popconfirm,
    Select,
    Skeleton,
    notification,
    theme,
} from "antd";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { useEffect, useState } from "react";
import { useQuery } from "react-query";
import HTTP from "../../services/httpService";
import CustomHeader from "../common/Header";
import CustomTable from "../common/Table";
dayjs.extend(customParseFormat);

const { Option } = Select;

function Expenditure() {
    const token = theme.useToken();
    const staff_id = localStorage.getItem("x-dashboard-staffid");
    const [tableData, setTableData] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [formData, setFormData] = useState({
        staff_id,
        page: 0,
        limit: 10,
        sorting: 1,
        sort_by: "updated_at",
    });
    const [addEditModalVisible, setAddEditModalVisible] = useState(false);
    const [title, setTitle] = useState(false);
    const [form] = Form.useForm();

    const columns = [
        {
            title: "Software Name",
            dataIndex: "software_name",
            key: "software_name",
        },
        {
            title: "Price",
            dataIndex: "price",
            key: "price",
        },
        {
            title: "price per",
            dataIndex: "price_by",
            key: "price_by",
            render: (text) => <p>{text == 1 ? "Month" : "Year"}</p>,
        },
        {
            title: "Action",
            render: (record) => (
                <>
                    <Popconfirm
                        onConfirm={() => deleteRecord(record.id)}
                        title="Are you sure want to delete?"
                        icon={
                            <QuestionCircleOutlined
                                style={{
                                    color: "red",
                                }}
                            />
                        }
                    >
                        <DeleteOutlined
                            style={{ color: token.colorError }}
                            disabled={false}
                        />
                    </Popconfirm>
                    <EditOutlined
                        style={{ color: token.colorPrimary }}
                        id={record.id}
                        onClick={() => editRecord({ ...record })}
                    />
                </>
            ),
        },
    ];

    const {
        status: ExpenditureStatus,
        data: ExpenditureRes,
        refetch: getExpenditure,
    } = useQuery(
        "Expenditure",
        async () => {
            return await HTTP("/software/getSoftwarePriceDetails", {
                ...formData,
            });
        },
        { enabled: false },
    );

    useEffect(() => {
        getExpenditure();
    }, []);

    useEffect(() => {
        getExpenditure();
    }, [formData]);

    useEffect(() => {
        if (ExpenditureStatus === "success") {
            const { data: tableData, total } = ExpenditureRes;
            setTableData(tableData);
            setTotalRecords(total);
        }
    }, [ExpenditureStatus, ExpenditureRes]);

    function handleTableChange(pagination, _, sorter) {
        const { current, pageSize } = pagination;
        const { order, field } = sorter;
        const others = {
            page: current - 1,
            limit: pageSize,
        };
        if (order !== undefined) {
            others.sorting = order === "ascend" ? 1 : 2;
            others.sort_by = field;
        } else {
            delete formData.sorting;
            delete formData.sort_by;
        }
        const newFormData = { ...formData, ...others };
        setFormData(newFormData);
    }

    function openAddModal() {
        setTitle("Add");
        setAddEditModalVisible(true);
    }

    function closeAddEditModal() {
        form.resetFields();
        setAddEditModalVisible(false);
    }

    async function handleSubmit(value) {
        if (!value.is_service) value.service_type = 0;

        if (value.price_year) {
            value.price_year = value.price_year.year();
        }
        if (value.price_month) {
            value.price_month = value.price_month.month();
        }
        console.log("value", value);
        let url = "/software/addSoftwarePriceDetails";
        if (value.id && value.id != "")
            url = "/software/editSoftwarePriceDetails";
        const { success, data, message } = await HTTP(url, {
            ...value,
            staff_id,
        });
        if (success) {
            getExpenditure();
            notification["info"]({
                message: "Action performed successfully.",
            });
        } else {
            notification["error"]({
                message: message,
            });
        }
        closeAddEditModal();
    }

    async function deleteRecord(id) {
        const { success, data, message } = await HTTP(
            "/software/deleteSoftwarePriceDetails",
            {
                staff_id,
                id,
            },
        );
        if (success) {
            getExpenditure();
            notification["info"]({
                message: "Action performed successfully.",
            });
        } else {
            notification["error"]({
                message: message,
            });
        }
    }

    async function editRecord(record) {
        setTitle("Edit");
        record.service_type == 0 && delete record.service_type;
        const formData = { ...record };
        formData.price_month = dayjs().set("month", record.price_month);
        if (record.price_year != 0) {
            formData.price_year = dayjs().set("year", record.price_year);
        } else {
            delete formData.price_year;
        }
        form.setFieldsValue(formData);
        setAddEditModalVisible(true);
    }

    return (
        <>
            <Card className="dashboard-container">
                <CustomHeader
                    extraAfter={
                        <div>
                            <Button
                                type="primary"
                                style={{ marginRight: "5px" }}
                                onClick={openAddModal}
                            >
                                <PlusOutlined /> Add
                            </Button>
                        </div>
                    }
                />
                <Card className="box-shadow margin-10">
                    {ExpenditureStatus === "loading" ||
                    ExpenditureStatus === "idle" ? (
                        <Skeleton
                            active
                            title={false}
                            paragraph={{ rows: 20, width: 40 }}
                        />
                    ) : (
                        <CustomTable
                            columns={columns}
                            tableData={tableData}
                            noOfrecords={totalRecords}
                            handleTableChange={handleTableChange}
                            rowKey="id"
                            className="serrver-queue-table"
                        />
                    )}
                </Card>
            </Card>
            <Modal
                title={title}
                destroyOnHidden
                open={addEditModalVisible}
                onCancel={closeAddEditModal}
                footer={""}
            >
                <Form
                    form={form}
                    name="basic"
                    labelCol={{
                        span: 10,
                    }}
                    wrapperCol={{
                        span: 16,
                    }}
                    onFinish={handleSubmit}
                    autoComplete="off"
                >
                    <Form.Item
                        label="S/W Name"
                        name="software_name"
                        rules={[
                            {
                                required: true,
                                message: "Please Enter S/W Name..!!",
                            },
                        ]}
                    >
                        <Input id="software_name" />
                    </Form.Item>
                    <Form.Item
                        label="Price"
                        name="price"
                        rules={[
                            {
                                required: true,
                                message: "Please Enter Price..!!",
                            },
                        ]}
                    >
                        <Input id="price" />
                    </Form.Item>
                    <Form.Item
                        label="Price Per"
                        name="price_by"
                        rules={[
                            {
                                required: true,
                                message: "Please Select Price Per..!!",
                            },
                        ]}
                    >
                        <Select id="price_by">
                            <Option value={1}>Month</Option>
                            <Option value={2}>Year</Option>
                        </Select>
                    </Form.Item>
                    <Form.Item
                        shouldUpdate={(prevValues, currentValues) =>
                            prevValues.price_by !== currentValues.price_by
                        }
                    >
                        {({ getFieldValue }) =>
                            getFieldValue("price_by") == 1 && (
                                <Form.Item
                                    label="Month"
                                    name="price_month"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please Select Month..!!",
                                        },
                                    ]}
                                    valuePropName="defaultValue"
                                >
                                    <DatePicker
                                        defaultValue={dayjs()}
                                        format={"MMM"}
                                        id="price_month"
                                        picker="month"
                                    />
                                </Form.Item>
                            )
                        }
                    </Form.Item>
                    <Form.Item
                        label="Year"
                        name="price_year"
                        rules={[
                            {
                                required: true,
                                message: "Please Select Year..!!",
                            },
                        ]}
                        valuePropName="defaultValue"
                    >
                        <DatePicker
                            defaultValue={dayjs()}
                            format={"YYYY"}
                            id="price_year"
                            picker="year"
                        />
                    </Form.Item>

                    <Form.Item name="id" className="hidden">
                        <Input id="id" disabled></Input>
                    </Form.Item>
                    <Form.Item
                        wrapperCol={{
                            offset: 8,
                            span: 16,
                        }}
                    >
                        <Button type="primary" htmlType="submit">
                            Submit
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    );
}

export { Expenditure };
